import { createSelector } from 'reselect';
import {
  ActivitySearch,
  ResearcherSearch,
} from 'components/Search/Results/helpers';

import { getSearchOrigin } from 'components/Search/Results/helpers';
import { groupedKeys } from 'components/Search/Filters/keys';

export const getFilter = ({ filters }, id, group) => {
  if (group && filters[group]) {
    return filters[group][id];
  }
  return filters[id];
};

export const getFiltersByGroupId = ({ filters }, group) => {
  if (group && filters[group]) {
    return filters[group];
  }
  return null;
};
export const getHasResults = ({
  view,
  searchRequest: { res, orgRes, activityRes, loading },
}) => {
  if (ActivitySearch(view)) {
    return (
      !loading &&
      activityRes &&
      Object.keys(activityRes).length > 0 &&
      activityRes.totalResults > 0
    );
  }

  if (!ResearcherSearch(view)) {
    return (
      !loading && Object.keys(orgRes).length > 0 && orgRes.totalResults > 0
    );
  }

  return !loading && Object.keys(res).length > 0 && res.totalResults > 0;
};

export const getHasValidQuery = ({ filters, view }) => {
  const tradeshowSubFilterSelected = !(
    filters.tradeshow &&
    !(
      filters.thisShowOnly ||
      filters.exhibitingShow ||
      filters.presentingAtTradeshow
    )
  );

  return (
    tradeshowSubFilterSelected &&
    filters.category &&
    Object.entries(filters.category).filter(
      ([key, value]) => value && (!ActivitySearch(view) || key !== 'profile')
    ).length > 0
  );
};

export const getListsRequest = createSelector(
  s => s.listsRequest,
  req => ({
    res: req.res || [],
    loading: req.loading,
    error: req.error,
  })
);

export const getSearchRequest = state => {
  const origin = getSearchOrigin(state.view);
  let res = {};
  if (origin === 'ResearcherSearch') {
    res = state.searchRequest.res || {};
  } else if (origin === 'OrganisationSearch') {
    res = state.searchRequest.orgRes || {};
  } else if (origin === 'ActivitySearch') {
    res = state.searchRequest.activityRes || {};
  }

  return {
    res,
    loading: state.searchRequest.loading,
    error: state.searchRequest.error,
    termCountError: state.searchRequest.termCountError,
  };
};

export const getOrgInsightsSearchRequest = state => {
  return {
    res: state.searchRequest.orgVisualisations,
    loading: state.searchRequest.insightsLoading,
    error: state.searchRequest.error,
  };
};

export const getGeoSearchData = createSelector(
  [s => s.view, s => s.geoSearchData],
  (view, req) => (ResearcherSearch(view) ? req.res : req.orgRes) || {}
);

export const getHasFilters = (state, keys) => {
  const currentKeys = Object.keys(state.filters);
  return keys.find(key => currentKeys.includes(key));
};

export const getActiveFilters = (state, keys) => {
  const grouped = Object.keys(groupedKeys);
  const toGroupMapping = {};
  let currentKeys = [];
  for (let key of Object.keys(state.filters)) {
    currentKeys.push(key);
    if (grouped.includes(key)) {
      for (let grKey of Object.keys(state.filters[key])) {
        currentKeys.push(grKey);
        toGroupMapping[grKey] = key;
      }
    }
  }
  return keys
    .filter(key => currentKeys.includes(key))
    .map(k => (toGroupMapping[k] ? toGroupMapping[k] : k));
};

export const getShowRefreshDialog = state => state.showRefreshDialog;

export const getNextResultsForRefresh = state => state.nextResults;

export const getExternalSearch = state => state.externalSearch;

export const getLastSuccessfulSearch = state => state.lastSuccessfulSearch;

export const isPdfExportRunning = state => state.isPdfExportRunning;

export const getSortBy = state => state.sortBy;

export const getOrgSortBy = state => state.orgSortBy;

export const getSearchView = state => state.view;

export const getFilters = state => state.filters;

export const getRestoringState = state => state.restoringState;

export const getShowBuilder = state => state.showBuilder;

export const getSearchBuilderFields = (state, id) =>
  state.searchBuilderFields[id] || {};

export const getResearcherIds = state => state.researcherIds;

export const getListAssignedToResearcher = state =>
  state.listAssignedToResearchers;

export const getListAssignedToResearcherAvailable = state =>
  state.listAssignedToResearcherAvailable;

export const getOrganisationIds = state => state.organisationIds;

export const getListAssignedToOrganisation = state =>
  state.listAssignedToOrganisations;

export const getBlockedForExport = state => state.blockedForExport;
export const getIsCleared = state => state.isCleared;

export const getMapRegion = state => state.mapRegion;

export const getFilterSectionIsCollapsed = (state, sectionKey) =>
  !state.openFilterSections[sectionKey];

export const hasDissmissedVCFundingSortModal = state =>
  !!state.dismissedVCFundingSortModal;

export const getShowVCFundingSortModal = state =>
  !!state.showVCFundingSortModal;

export const getIsCurrentSearchAI = state => !!state.filters?.aiFilterSessionId;

export const getAddMembersToListFromSearchError = state =>
  state.addMembersToListFromSearchError;

export const getFavourites = state =>
  (state.favourites || []).sort((a, b) => a.timestamp - b.timestamp);

export const getExplicitFavourites = createSelector(getFavourites, favourites =>
  favourites.filter(fav => fav.isExplicit)
);
